import React from 'react';
import { StarIcon } from 'lucide-react';
import { LazyYouTubeEmbed } from './LazyYouTubeEmbed';
import { useLanguage } from '../contexts/LanguageContext';
export function TestimonialSection() {
  const {
    t
  } = useLanguage();
  const testimonials = [{
    videoId: '7hdXfRr40BM',
    name: 'Luis Warkuss',
    quote: 'Wir haben 100.000 € extra jeden Monat allein durch das Follow-Up generiert.'
  }, {
    videoId: 'KtoJKbnTgOU',
    name: 'Henri CL',
    quote: 'Wir sind von 250.000 € auf über 450.000 € Monatsumsatz gewachsen.'
  }, {
    videoId: 'a3z3I3ym39o',
    name: 'Steuer Mentoring',
    quote: 'Wir haben unsere Umsätze verdreifacht bis verfünffacht – ohne unser Vertriebsteam massiv ausbauen zu müssen.'
  }];
  return <section id="testimonials" className="py-16 lg:py-24 bg-[#0a0e1a]" data-id="element-258">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-259">
        {/* Section Header */}
        <div className="text-center mb-12 lg:mb-16" data-id="element-260">
          <div className="inline-block bg-[#ff6b35]/10 border border-[#ff6b35]/20 rounded-full px-4 py-1.5 mb-4" data-id="element-261">
            <span className="text-[#ff6b35] text-sm font-medium" data-id="element-262">
              {t('testimonials.badge')}
            </span>
          </div>
          <h2 className="text-3xl sm:text-4xl font-bold text-white mb-4" data-id="element-263">
            {t('testimonials.title')}
          </h2>
          <p className="text-gray-400 text-lg" data-id="element-264">{t('testimonials.subtitle')}</p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8" data-id="element-265">
          {testimonials.map((testimonial, index) => <div key={index} className="bg-gradient-to-br from-[#1a1f36] to-[#111827] rounded-xl border border-white/10 overflow-hidden hover:border-[#ff6b35]/30 transition-colors" data-id="element-266">
              {/* Video Embed */}
              <div className="relative aspect-video bg-black" data-id="element-267">
                <LazyYouTubeEmbed videoId={testimonial.videoId} title={`Testimonial ${index + 1}`} data-id="element-268" />
              </div>

              {/* Content */}
              <div className="p-6" data-id="element-269">
                {/* Stars */}
                <div className="flex gap-1 mb-3" data-id="element-270">
                  {[1, 2, 3, 4, 5].map(star => <StarIcon key={star} className="w-4 h-4 text-[#ff6b35] fill-[#ff6b35]" data-id="element-271" />)}
                </div>

                {/* Quote */}
                <p className="text-gray-300 text-sm mb-4" data-id="element-272">
                  "{testimonial.quote}"
                </p>

                {/* Author */}
                <div className="flex items-center gap-3" data-id="element-273">
                  <div className="w-10 h-10 rounded-full bg-gradient-to-br from-[#ff6b35] to-[#ff5722] flex items-center justify-center text-white font-bold text-sm" data-id="element-274">
                    {testimonial.name.charAt(0)}
                  </div>
                  <div data-id="element-275">
                    <div className="text-white font-medium text-sm" data-id="element-276">
                      {testimonial.name}
                    </div>
                  </div>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}